<template>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }" v-if="ShowButton">
        <v-btn color="primary" class="white--text" v-bind="attrs"
          v-on="on" small>Thêm mới <v-icon right>mdi mdi-shape-rectangle-plus</v-icon> </v-btn>
      </template>
      <v-card>
        <v-form ref="form" lazy-validation>
        <v-card-title>
          <span class="text-h5" v-if="!addData.Id">Thêm mới</span>
          <span class="text-h5" v-else>Cập nhật</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
              >
                <v-textarea
                  v-model="addData.GhiChu"
                  label="Ghi chú:"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Đóng
          </v-btn>
          <v-btn
            color="green"
            :disabled="disabled"
            :loading="loading"            
            @click="TaoMoi"
            class="white--text"
            v-if="!addData.Id"
          >
            Tạo
          </v-btn>
          <v-btn
            color="green"
            :loading="loading"            
            @click="CapNhat"
            class="white--text"
            v-else
          >
            Cập nhật
          </v-btn>
        </v-card-actions>
      </v-form>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
    data: (vm) => ({
      menuDateStart:false,
      menuDateEnd:false,
      editItem: {},
      addData: {},
      dialog: false,
      loading:false,
      disabled: true,
      Swal: vm.$swal,
      moment: vm.moment
    }),
    props: {
      ListStations: Array,
      ListTypeOfTickets: Array,
      Rules: Object,
      isUpdated: Boolean,
      ShowButton: {
        type: Boolean,
        defaut: true,
        required: false,
      },
    },
    methods: {
      EditItem(item){
        this.addData = item;
        this.dialog = true;
      },
      CapNhat(){
        this.loading = true;
        this.$Request.post('/ticket/update',this.addData).then(response => {
            if(response.data.success === true)
            {
              this.dialog = false;
              this.addData = this.dataDefault;
              this.$emit("update:isUpdated", true);
              const msg = response.data.msg || "Đã cập nhật thành công !";
              this.Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: msg,
                  showConfirmButton: false,
                  timer: 1500
              });
            }else{
              const msg = response.data.msg || "Có lỗi xảy ra !";
              this.Swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: msg,
                  showConfirmButton: false,
                  timer: 1500
              });
            }
        }).finally(()=>{
          this.loading = false;
        });
      },
      TaoMoi(){
        this.loading = true;
        this.$Request.post('/ticket/create',this.addData).then(response => {
            if(response.data.success === true)
            {
              this.dialog = false;
              this.addData = this.dataDefault;
              this.$emit("update:isUpdated", true);
              const msg = response.data.msg || "Đã thêm thành công !";
              this.Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: msg,
                  showConfirmButton: false,
                  timer: 1500
              });
            }else{
              const msg = response.data.error || "Có lỗi xảy ra !";
              this.Swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: msg,
                  showConfirmButton: false,
                  timer: 1500
              });
            }
        }).finally(()=>{
          this.loading = false;
        });
      },
      CheckValid(){
        if(this.$refs.form === undefined){
          this.disabled = true;
        }else{
          this.disabled = !this.$refs.form.validate();
        }
      }
    },
    watch: {
    },
    computed: {
      dataDefault(){
        return {
          'GhiChu': ""
        };
      },
      isValid(){
        if(typeof(this.$refs.form) === "undefined") return false;
        return this.$refs.form.validate();
      }
    },
    mounted(){
      this.addData = this.dataDefault;
    }
}
</script>